import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { sql } from "../componentes/api.js";
import Button from "react-bootstrap/Button";
import Alert from "@mui/material/Alert";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import Badge from "@mui/material/Badge";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import { RUTA_SERVIDOR, RUTA_IMG } from "../componentes/config.js";

const Foro = (props) => {
  const [cargando, setCargando] = useState(false);
  const [proyectos, setProyectos] = useState([]);
  const [idProyecto, setIdProyecto] = useState(props.IdProyecto);
  const [foros, setForos] = useState([]);
  const [idForo, setIdForo] = useState("");
  const [opiniones, setOpiniones] = useState([]);
  const [opinion, setOpinion] = useState("");
  const [mostrarProyectos, setMostrarProyectos] = useState(false);

  useEffect(() => {
    if (props.tipoParticipante === 1) {
      //Es super usuario
      setMostrarProyectos(true);
      cargarListas(
        "getCampo",
        {
          Campos: "Id, Nbre",
          Tabla: "proyectos",
          Campo: "Activo",
          Signo: "=",
          Valor: "1",
        },
        "proyectos"
      );
    } else {
      setMostrarProyectos(false);
      cargarListas(
        "getCbos",
        {
          Campos: "Id, Nbre",
          Tabla: "foro_temas",
          Campo: "Proyecto=" + props.idProyecto,
        },
        "foros"
      );
    }
    setIdProyecto(props.idProyecto);
  }, [props.idProyecto]);

  const asignarDato = (event) => {
    event.preventDefault();

    if (event.target.name === "idProyecto") {
      setIdProyecto(event.target.value);
      setIdForo("");
      setOpiniones([]);
      cargarListas(
        "getCbos",
        {
          Campos: "Id, Nbre",
          Tabla: "foro_temas",
          Campo: "Proyecto=" + event.target.value,
        },
        "foros"
      );
    } else if (event.target.name === "idForo") {
      setIdForo(event.target.value);
      setOpiniones([]);
      cargarOpiniones(event.target.value);
    }
  };

  const cargarOpiniones = (foro) => {
    cargarListas(
      "getForoOpinion",
      { IdProyecto: idProyecto, IdForo: foro },
      "opiniones"
    );
  };

  const calificar = async (event, idForoOpinion, cal) => {
    event.preventDefault();
    try {
      const response = await sql("updateForoMeGusta", "PUT", {
        idForoOpinion: idForoOpinion,
        calificacion: cal,
      });
      cargarOpiniones(idForo);
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al grabar el LIKE", error]);
    }
  };

  const cargarListas = async (url, cuerpo, array) => {
    try {
      // const reg = await sql(url, "POST", cuerpo);

      const reg = await fetch(RUTA_SERVIDOR + url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cuerpo),
      });

      const lista = await reg.json();
      if (lista.toString().length > 0) {
        if (array === "proyectos") {
          setProyectos(lista);
          setIdProyecto(0);
        } else if (array === "foros") {
          setForos(lista);
        } else if (array === "opiniones") {
          setOpiniones(lista);
        } else {
          //Grabo opiniones
          cargarOpiniones(idForo);
          props.mostrarMsg([
            "Gracias por participar!",
            "Su opinión es valiosa para el foro",
          ]);
        }
      } else {
        if (array === "foros") {
          setForos([]);
        } else if (array === "proyectos") {
          setProyectos([]);
        } else if (array === "opiniones") {
          setOpiniones([]);
        } else {
          //Grabo opiniones
        }
      }

      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg(["Ocurrió un error al cargar los datos!"]);
    }
  };

  const grabar = async () => {
    try {
      cargarListas(
        "setForoOpinion",
        {
          IdForo: idForo,
          IdProyecto: idProyecto,
          IdParticipante: props.idUsuario,
          Detalle: opinion,
        },
        "grabar"
      );
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los proyectos",
        error,
      ]);
    }
  };

  const publicar = (event) => {
    event.preventDefault();
    if (idProyecto === "") {
      props.mostrarMsg(["Por favor seleccione un Proyecto!"]);
    } else if (idForo === "") {
      props.mostrarMsg(["Por favor seleccione un Foro!"]);
    } else if (opinion === "") {
      props.mostrarMsg(["Por favor escriba su opinión sobre el tema!"]);
    } else {
      grabar();
    }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="row card">
        <Alert severity="success">
          <strong>FORO</strong>
          {cargando === true && (
            <div className="spinner-grow text-primary" role="status"></div>
          )}
        </Alert>

        {mostrarProyectos === true && (
          <div className="row form-floating mb-3 mt-2 m-1">
            <select
              type="text"
              className="form-control"
              name="idProyecto"
              value={idProyecto}
              onChange={(event) => {
                asignarDato(event);
              }}
            >
              <option key="0" value="0">
                Por favor seleccione un Proyecto...
              </option>
              {proyectos.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
            <label htmlFor="idProyecto">Proyecto</label>
          </div>
        )}

        <div className="row form-floating mb-3 mt-2 m-1">
          <select
            type="text"
            className="form-control"
            name="idForo"
            value={idForo}
            onChange={(event) => {
              asignarDato(event);
            }}
          >
            <option key="0" value="0">
              Por favor seleccione un Foro...
            </option>
            {foros.length > 0 &&
              foros.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
          </select>
          <label htmlFor="idForo">Foro</label>
        </div>

        <Alert severity="info">
          <strong>Escriba aquí su opinión acerca del tema del foro</strong>
        </Alert>

        <div className="row mt-3 mb-3">
          <div className="col-sm-10">
            <TextField
              fullWidth
              id="fullWidth"
              multiline
              onChange={(event) => setOpinion(event.target.value)}
            />
          </div>

          <div className="col-sm-2">
            <Button
              className="form-control"
              variant="primary"
              onClick={(event) => publicar(event)}
            >
              Publicar
            </Button>
          </div>
        </div>
      </div>

      <Divider className="mb-3 mt-3" />

      <div className="row mt-3">
        {opiniones.length > 0 &&
          opiniones.map((reg, i) => {
            return (
              <div className="row mt-1" key={i}>
                <Card>
                  <Card.Body>
                    <CardHeader
                      avatar={<Avatar src={RUTA_IMG + "fotos/" + reg.Foto} />}
                      title={
                        reg.NbreParticipante +
                        " (" +
                        reg.NbreMunicipio.toLowerCase() +
                        ")"
                      }
                      subheader={
                        reg.FechaReg.substring(0, 10) +
                        " " +
                        reg.FechaReg.substring(11, 16)
                      }
                    />

                    {/* Zona para mirar los anexos de guías */}
                    <blockquote className="blockquote mb-0">
                      <footer className="blockquote-footer">
                        <cite title="Source Title">{reg.Detalle}</cite>
                      </footer>
                    </blockquote>
                    <Divider className="mb-3 mt-3" />

                    <CardActions disableSpacing>
                      <Stack spacing={2} direction="row">
                        <Badge
                          badgeContent={reg.MeGusta}
                          color="success"
                          onClick={(event) => {
                            calificar(event, reg.IdForo, 1);
                          }}
                        >
                          <ThumbUpIcon color="primary" />
                        </Badge>
                        <Badge
                          badgeContent={reg.NoGusta}
                          color="secondary"
                          onClick={(event) => {
                            calificar(event, reg.IdForo, 0);
                          }}
                        >
                          <ThumbDownOffAltIcon color="secondary" />
                        </Badge>
                      </Stack>
                    </CardActions>
                  </Card.Body>
                </Card>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Foro;
